export const SERVER_MAP = {
  FIREBASE: 'us-central1-lunar-brace-213823.cloudfunctions.net',
  SPORTS_RADAR: 'api.sportradar.us',
};

export const SOURCES = {
  FIREBASE: 'FIREBASE',
  SPORTS_RADAR: 'SPORTS_RADAR',
};
